window.CKEDITOR_BASEPATH = '/dist/ckeditor4/';
